import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/theme.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress known benign ResizeObserver loop errors in development
const originError = console.error;
console.error = (...args) => {
  if (args.length && typeof args[0] === 'string' && args[0].includes('ResizeObserver loop')) return;
  originError(...args);
};
window.addEventListener('error', (e) => {
  if (e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
  }
});


const initialTheme = (() => {
  try {
    const storedTheme = localStorage.getItem('theme');
    const theme = storedTheme || 'light';
    document.documentElement.dataset.theme = theme;
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    if (!storedTheme) {
      localStorage.setItem('theme', theme);
    }
    return theme;
  } catch (error) {
    document.documentElement.dataset.theme = 'light';
    return 'light';
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App initialTheme={initialTheme} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
